module.exports = __webpack_public_path__ + "img/5.7ba09cd1.png";